var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBulb = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h2.236v.953H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M0 0h13.752v18.88H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.76 5.237a.48.48 0 0 1-.339-.144l-.908-.904a.477.477 0 0 1 .342-.816c.129 0 .25.05.341.141l.899.906a.473.473 0 0 1 .003.675.475.475 0 0 1-.337.142",
  fill: "#000"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 11.524)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.476.953a.477.477 0 0 1 0-.953h1.28c.131 0 .254.05.345.142a.48.48 0 0 1-.345.811H.475Z",
  fill: "#000",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12 2.239a.482.482 0 0 1-.48-.484V.476c0-.262.215-.476.48-.476s.48.214.48.476V1.76a.48.48 0 0 1-.48.48M19.24 5.237a.464.464 0 0 1-.332-.14l-.005-.006a.47.47 0 0 1 0-.671l.902-.907a.478.478 0 0 1 .681.001.485.485 0 0 1 .002.68l-.904.901a.483.483 0 0 1-.344.142",
  fill: "#000"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.124 5.12)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.88 7.31a.48.48 0 0 1 .48.48V12a.93.93 0 0 1-.009.083l-.09.712.717.004h1.584l.187-.283c.174-.262.38-.515.615-.752l1.328-1.322-.062-.03a5.882 5.882 0 0 0 1.166-3.533 5.868 5.868 0 0 0-1.735-4.186A5.869 5.869 0 0 0 6.876.956a5.864 5.864 0 0 0-4.183 1.735A5.874 5.874 0 0 0 .956 6.88c0 1.583.616 3.071 1.734 4.19l.703.698c.23.233.436.486.61.748l.188.283h2.301l-.088-.724c-.004-.03-.008-.062-.008-.075V7.79c0-.264.217-.48.484-.48Zm-2.133 7.17c.034.238.05.467.05.68v.678c0 1.148.933 2.082 2.079 2.082 1.146 0 2.079-.934 2.079-2.082v-.677c0-.214.017-.443.05-.68l.102-.722H4.646l.101.72Zm2.13 4.4a3.045 3.045 0 0 1-3.043-3.042v-.677a3.882 3.882 0 0 0-1.12-2.718l-.699-.699A6.835 6.835 0 0 1 0 6.879c0-1.837.716-3.564 2.015-4.864A6.83 6.83 0 0 1 6.876 0c1.84 0 3.569.716 4.868 2.015a6.832 6.832 0 0 1 2.008 4.864 6.81 6.81 0 0 1-2.014 4.864l-.699.699a3.882 3.882 0 0 0-1.12 2.719v.677a3.045 3.045 0 0 1-3.043 3.041Z",
  fill: "#000",
  mask: "url(#d)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M22.244 12.476a.479.479 0 0 1-.48-.476c0-.263.216-.476.48-.476h1.28a.48.48 0 0 1 .476.48.482.482 0 0 1-.476.472h-1.28Z",
  fill: "#000"
}))));

export default SvgBulb;